import { Controller } from "@hotwired/stimulus"
import { es, en } from "intl-tel-input/i18n";
import intlTelInput from "intl-tel-input"


export default class extends Controller {
  static targets = ["input"]
  static values = {
    locale: String,
    defaultCountry: String
  }

  connect() {
    this.initializePhoneInput()
    this.handleResize = this.handleResize.bind(this)
    window.addEventListener('resize', this.handleResize)
  }

  disconnect() {
    if (this.iti) {
      this.iti.destroy()
    }
    window.removeEventListener('resize', this.handleResize)
  }

  handleResize() {
    const countryList = document.querySelector('.iti__country-list')
    if (countryList) {
      this.positionCountryList(countryList)
    }
  }

  positionCountryList(countryList) {
    const isMobile = window.innerWidth < 768
    if (isMobile) {
      countryList.style.position = 'fixed'
      countryList.style.bottom = '80px'
      countryList.style.left = '1rem'
      countryList.style.right = '1rem'
      countryList.style.width = 'auto'
      countryList.style.maxHeight = '40vh'
    } else {
      countryList.style.position = 'absolute'
      countryList.style.bottom = 'auto'
      countryList.style.left = '0'
      countryList.style.right = 'auto'
      countryList.style.width = '100%'
      countryList.style.maxHeight = '200px'
    }
  }

  initializePhoneInput() {
    const locale = this.localeValue || 'en'

    const i18nTranslations = locale === 'es' ? es : en

    this.iti = intlTelInput(this.inputTarget, {
      useFullscreenPopup: false,
      initialCountry: this.defaultCountryValue || "es",
      preferredCountries: ["us", "gb", "es"],
      separateDialCode: true,
      loadUtils: () => import("intl-tel-input/build/js/utils.js"),
      language: locale,
      i18n: i18nTranslations,
    })

    this.inputTarget.addEventListener('focus', () => {
      setTimeout(() => {
        const countryList = document.querySelector('.iti__country-list')
        if (countryList) {
          this.positionCountryList(countryList)
        }
      }, 0)
    })
  }

  validate() {
    if (this.iti.isValidNumber()) {
      this.inputTarget.classList.remove('border-red-500')
      return true
    } else {
      this.inputTarget.classList.add('border-red-500')
      return false
    }
  }

  getNumber() {
    return this.iti.getNumber()
  }
}
